const EXTRACTED_FILE_INTERNAL_MARKERS = /_merged|_extracted|_macproc|-Transformed/gi;

function splitNameAndExtension(fileName) {
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex <= 0) {
    return {
      baseName: fileName,
      extension: "",
    };
  }

  return {
    baseName: fileName.substring(0, lastDotIndex),
    extension: fileName.substring(lastDotIndex),
  };
}

function isMergedDocument(isMerged) {
  return Number(isMerged) >= 1;
}

export function getExtractedFileDisplayName(fileName, isMerged) {
  if (!fileName || typeof fileName !== "string") {
    return fileName;
  }

  if (!isMergedDocument(isMerged)) {
    return fileName;
  }

  const { baseName } = splitNameAndExtension(fileName);
  return baseName.replace(EXTRACTED_FILE_INTERNAL_MARKERS, "");
}

function usableName(value) {
  return typeof value === "string" && value.trim() !== "" ? value : undefined;
}

export function getExtractedJsonDownloadName(document) {
  const extractName = usableName(document?.uploadDocumentName);
  if (extractName) {
    return extractName.replace(/[.]xlsx/gi, ".json");
  }

  const sourceName = usableName(document?.documentName);
  if (sourceName) {
    return `${splitNameAndExtension(sourceName).baseName}.json`;
  }

  return `${usableName(document?.submissionIdentifier) || "extract"}.json`;
}

export function getExtractedFileDownloadName(fileName, isMerged) {
  if (!fileName || typeof fileName !== "string") {
    return fileName;
  }

  if (!isMergedDocument(isMerged)) {
    return fileName;
  }

  const { baseName, extension } = splitNameAndExtension(fileName);
  return `${baseName.replace(EXTRACTED_FILE_INTERNAL_MARKERS, "")}${extension}`;
}
